import React, { useState, useMemo } from 'react'
import { Box, Grid } from '@mui/material'
import PointsSummaryCard from '../../../../components/leaderboard/PointsSummaryCard'
import WaysToEarnPoints from '../../../../components/leaderboard/WaysToEarnPoints'
// Soft-launch: LeaderboardRankings temporarily disabled
// import LeaderboardRankings from '../../../../components/leaderboard/LeaderboardRankings'
import {
  // Soft-launch: ILeaderboardRanking temporarily unused
  // ILeaderboardRanking,
  IWayToEarn,
} from '../../../../types/leaderboardTypes'
import ShareInvite from '../../../../components/ShareInvite'
import CampaignsAddEditDialog from '../../influencerMarket/components/CampaignsAddEditDialog'
import {
  selectRestaurantAlias,
  selectRestaurantIsSubscribed,
  selectLogin,
} from '../../../../store/authSlice'
import { useAppSelector } from '../../../../store'
import { ROUTES } from '../../../../helpers/routes-helper'
import { openInstagram } from '../../../../helpers/instagram-helper'
import useAppUtilities from '../../../../hooks/useAppUtilities'
import {
  selectShouldOpen,
  selectMessage,
  selectSeverity,
  setOpen,
} from '../../../../store/restaurantSlice'
import { MuiAlert, MuiSnackbar } from '../../../eater/styled/global.styled'

const LeaderboardTab: React.FC = () => {
  const { navigate, dispatch } = useAppUtilities()
  const [shareInvite, setShareInvite] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const restaurantAlias = useAppSelector(selectRestaurantAlias)
  const isSubscribed = useAppSelector(selectRestaurantIsSubscribed)
  const login = useAppSelector(selectLogin)
  const restaurantShouldOpen = useAppSelector(selectShouldOpen)
  const restaurantMessage = useAppSelector(selectMessage)
  const restaurantSeverity = useAppSelector(selectSeverity)

  // Get restaurant points from restaurant DTO
  const restaurantPoints = (login?.restaurantDTO as any)?.points ?? 0

  // Subscription route - using RESTAURANT_SETTINGS for now
  const subscriptionRoute = ROUTES.RESTAURANT_SUBSCRIPTION ?? ROUTES.RESTAURANT_SETTINGS

  const waysToEarn: IWayToEarn[] = useMemo(() => {
    const baseWays: IWayToEarn[] = [
      {
        id: 'how-to-earn-points',
        title: 'How to earn points',
        action: 'View guide',
      },
      {
        id: 'refer-and-earn',
        title: 'Refer & earn',
        action: 'Invite restaurants and earn up to 10 points',
      },
      {
        id: 'follow-us-on-instagram',
        title: 'Follow Resactly on Instagram',
        action: 'Stay up to date',
      },
      {
        id: 'post-a-job',
        title: 'Post a campaign',
        action: 'Earn up to 200 points',
      },
      {
        id: 'renew-subscription',
        title: 'Renew subscription',
        action: isSubscribed
          ? "You're subscribed"
          : 'Keep earning and redeeming',
        earned: isSubscribed,
      },
    ]
    return baseWays
  }, [isSubscribed])

  // Soft-launch: LeaderboardRankingList temporarily disabled
  // const LeaderboardRankingList: ILeaderboardRanking[] = [
  //   { rank: 1, name: 'Alice Smith', points: 4000 },
  //   ...dummy data...
  // ]

  const onEarnPoint = async (item: IWayToEarn): Promise<void> => {
    switch (item.id) {
      case 'refer-and-earn':
        setShareInvite(true)
        break
      case 'post-a-job':
        setModalOpen(true)
        break
      case 'follow-us-on-instagram':
        // Open Resactly Instagram
        await openInstagram()
        break
      case 'renew-subscription':
        navigate(subscriptionRoute)
        break
      case 'how-to-earn-points':
        // If there is a help/FAQ route, navigate to it here, otherwise do nothing
        // For now, leave as non-clickable informational item
        break
      default:
        break
    }
  }

  const handleRedeemPoints = (): void => {
    if (isSubscribed) {
      navigate(ROUTES.REDEEM_POINTS_RESTARUANT)
    } else {
      navigate(ROUTES.RESTAURANT_SUBSCRIPTION)
    }
  }

  const handleCloseRestaurantSnackbar = (): void => {
    dispatch(setOpen(false))
  }

  return (
    <Box
      mt={2}
      sx={{
        height: '100%',
        overflow: 'auto',
      }}
    >
      <Grid container spacing={6} sx={{ height: '100%' }}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            height: { xs: '500px', md: '100%' },
          }}
        >
          <PointsSummaryCard
            onRedeemPoints={handleRedeemPoints}
            isSubscribed={isSubscribed}
            points={restaurantPoints}
          />
          <WaysToEarnPoints
            wayToEarnList={waysToEarn}
            onWayClick={() => {void onEarnPoint}}
          />
        </Grid>
        {/* Soft-launch: Leaderboard rankings temporarily disabled */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{ height: { xs: '400px', md: '100%' }, pb: { xs: 2, md: 0 } }}
        >
          {/* <LeaderboardRankings */}
          {/*  LeaderboardRankingList={LeaderboardRankingList} */}
          {/* /> */}
        </Grid>
      </Grid>
      <ShareInvite
        open={shareInvite}
        handleClose={() => setShareInvite(false)}
        url={`https://www.resactly.com/restaurant/${restaurantAlias}/details`}
      />
      <CampaignsAddEditDialog
        openEditModel={modalOpen}
        setOpenEditModel={setModalOpen}
      />
      <MuiSnackbar
        open={restaurantShouldOpen}
        onClose={handleCloseRestaurantSnackbar}
        autoHideDuration={5000}
      >
        <MuiAlert
          onClose={handleCloseRestaurantSnackbar}
          severity={restaurantSeverity ?? 'success'}
        >
          {restaurantMessage}
        </MuiAlert>
      </MuiSnackbar>
    </Box>
  )
}

export default LeaderboardTab
